import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { GoogleMaps } from './google-maps.namespace';

@NgModule()
export class DfModuleGoogleMapsModule {
    static forRoot(config?: DeepPartial<GoogleMaps.IAppConfig>): ModuleWithProviders<DfModuleGoogleMapsModule> {
        return {
            ngModule: DfModuleGoogleMapsModule,
            providers: [
                {
                    provide: GoogleMaps.OPTIONS,
                    useFactory: () => defaultsDeep(config, GoogleMaps.DEFAULT_OPTIONS)
                }
            ]
        };
    }
}
